export default "__VITE_ASSET__CmLVDG0f__"